import React, { useState } from 'react';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import CoquinRoulette from './CoquinRoulette';
import CoquinVerite from './CoquinVerite';
import CoquinConfessions from './CoquinConfessions';
import { defiPhysique, questionIntime, veriteShotCards, confessions } from '../data/coquin';

type CoquinSub = 'roulette' | 'verite' | 'confessions' | null;

interface CoquinModeGameProps {
  players: string[];
}

const subCategories = [
  { id: 'roulette' as const, icon: '🎡', title: 'Roulette des Gages', desc: 'Tourne la roue et assume' },
  { id: 'verite' as const, icon: '🌶️', title: 'Vérité ou Shot', desc: 'Réponds ou bois' },
  { id: 'confessions' as const, icon: '💣', title: 'Confessions', desc: 'Lève la main si t\'oses' },
];

export default function CoquinModeGame({ players }: CoquinModeGameProps) {
  const [selectedSub, setSelectedSub] = useState<CoquinSub>(null);
  const [tappedCard, setTappedCard] = useState<CoquinSub>(null);

  const handleSelectSub = (sub: CoquinSub) => {
    if (selectedSub || !sub) return;
    setTappedCard(sub);
    try { Haptics.impact({ style: ImpactStyle.Light }); } catch {}
    setTimeout(() => setSelectedSub(sub), 250);
  };

  const handleBackToSelector = () => {
    setSelectedSub(null);
    setTappedCard(null);
  };

  if (selectedSub === 'roulette') {
    return <CoquinRoulette players={players} defiPhysique={defiPhysique} questionIntime={questionIntime} onBack={handleBackToSelector} />;
  }
  if (selectedSub === 'verite') {
    return <CoquinVerite players={players} cards={veriteShotCards} onBack={handleBackToSelector} />;
  }
  if (selectedSub === 'confessions') {
    return <CoquinConfessions confessionsList={confessions} onBack={handleBackToSelector} />;
  }

  return (
    <div className="h-screen bg-gradient-to-b from-[#450a0a] via-[#5c1010] to-[#2a0505] flex flex-col items-center justify-center safe-top safe-bottom px-5">
      {/* Title */}
      <div className="mb-8 text-center">
        <span className="text-5xl block mb-3">🌶️</span>
        <h1 className="font-display font-black text-3xl text-white">Mode Coquin</h1>
        <p className="text-red-300/50 font-body text-sm mt-2">Choisis ton jeu</p>
      </div>

      {/* 3 sub-category cards */}
      <div className="w-full max-w-sm space-y-3">
        {subCategories.map((sub) => (
          <button
            key={sub.id}
            onClick={() => handleSelectSub(sub.id)}
            className={`w-full rounded-2xl p-5 text-left border transition-all duration-200 ${
              tappedCard === sub.id ? 'scale-105 shadow-[0_0_30px_rgba(239,68,68,0.5)]' : ''
            } ${tappedCard && tappedCard !== sub.id ? 'opacity-40' : ''}`}
            style={{
              background: 'linear-gradient(135deg, rgba(239,68,68,0.15) 0%, rgba(244,114,182,0.1) 100%)',
              borderColor: 'rgba(239,68,68,0.25)',
            }}
          >
            <div className="flex items-center gap-4">
              <span className="text-4xl flex-shrink-0">{sub.icon}</span>
              <div>
                <h3 className="font-display font-bold text-lg text-white">{sub.title}</h3>
                <p className="text-white/50 font-body text-sm">{sub.desc}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
